import React, { PropTypes } from 'react'
import CreatableSelect from 'react-select/lib/Creatable'
import { customCreatableSelectStyles } from '../customStyles.js'
import ReactSelect2, { components as reactSelectComponents } from 'react-select'
import styles from './WizardReactSelect.scss'


/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const DropdownIndicator = (props) => {
    return reactSelectComponents.DropdownIndicator && (
        <reactSelectComponents.DropdownIndicator {...props}>
            <span className={styles.downArrowHolder}>
                <span className={styles.downArrow}></span>
            </span>
        </reactSelectComponents.DropdownIndicator>
    )
}

/**
 * Custom dropdown indicator for react-select to be the similar style lik other elements on the page
 * @param {object} props
 */
export const NoOptionsMessage = (props) => {
    return reactSelectComponents.DropdownIndicator && (
        <reactSelectComponents.NoOptionsMessage {...props}>
            {props.selectProps.noOptionsLabel || _('noOptions')}
        </reactSelectComponents.NoOptionsMessage>
    )
}


const getDeleteIcon = () => {
    try {
        return require(`resources/images/a-trash_1x_ovbBlue.svg`)
    } catch (err) {
        return require(`resources/images/icn-no-result.svg`)
    }
}

/**
 *
 * @param {*} props
 */
const SelectRemovableOption = props => {
    return (
        <div className={styles.creatableOptionContainer}>
            <reactSelectComponents.Option {...props} className={styles.creatableOptionItem} />
            {props.data.isRecent ?
                <span>
                    <button type="button" className={styles.creatableOptionItem} onClick={event => {
                        event.preventDefault()
                        props.delete(props.value)
                    }}>
                        <img src={getDeleteIcon()} />
                    </button>
                </span>
                : null
            }
        </div>
    )
}

/**
 * This is a custom MultiValueRemove for react select to be able set a separate unremovable value in dropdown
 * but the rest is still dynamic
 * @param {object} props
 */
const MultiValueRemove = props => {
    return (
        <reactSelectComponents.MultiValueRemove {...props}>
            {!props.data.isPermanentSelected ? props.children : null}
            {!props.data.isPermanentSelected ? props.children : null}
        </reactSelectComponents.MultiValueRemove>
    )
}


const ValueContainer = ({ children, ...props }) => {
    return (<reactSelectComponents.ValueContainer {...props} className={styles.selectValueContainer}>
        <div className={styles.composeRecipients}>
            {children}
        </div>
        <div className={styles.ccButtonHolder}>
            {props.selectProps.showExtraButton ?
                <div className={styles.ccButtonInSelect} onClick={(e) => {
                    e.preventDefault()
                    e.stopPropagation()
                    props.selectProps.onClickExtraButton(e)
                }}>
                    CC
                </div>
                : null}
        </div>
    </reactSelectComponents.ValueContainer>)
}

export const CreatableSelectWrapper = ({ value, options, onBlur, onChange, formatCreateLabel, isCreatableSelect, noOptionsLabel, ...props }) => {
    let selectedValue = value
    if (typeof selectedValue === 'string') {
        // This code enables the select to work with the new react-select
        selectedValue = options && options.length > 0 ? (options.find(option => option.value === selectedValue) || { value: selectedValue, label: selectedValue }) : null
    }

    if (isCreatableSelect) {
        return (
            <CreatableSelect
                placeholder=""
                value={selectedValue}
                options={options}
                onChange={(newValue) => onChange(newValue)}
                onBlur={(ev) => {                    
                    onChange && ev.target.value ? onChange({ label: ev.target.value, value: ev.target.value }) : null
                }}
                {...props}
                isSearchable // Searchable is true by default
                styles={customCreatableSelectStyles}
                formatCreateLabel={(value) => `${formatCreateLabel} ${value}`}
                components={{
                    DropdownIndicator, NoOptionsMessage,
                    // Option: (p) => (SelectRemovableOption({ ...p, delete: setDeleteItemByOption })),
                    MultiValueRemove,/* MultiValueContainer,*/ ValueContainer
                }}
            />
        )
    } else {
        return (
            <ReactSelect2
                {...props}
                value={selectedValue}
                // onBlur={(ev) => {
                //     onChange ? onChange({ label: ev.target.value, value: ev.target.value }) : null
                // }}
                onChange={(newValue) => onChange(newValue)}
                options={options}
                noOptionsLabel={noOptionsLabel}
                openMenuOnFocus={true}
                placeholder={''}
                onBlurResetsInput={false}
                isSearchable
                styles={customCreatableSelectStyles}
                components={{
                    DropdownIndicator, NoOptionsMessage, 
                    // Option: (p) => (SelectRemovableOption({ ...p, delete: setDeleteItemByOption })),
                    MultiValueRemove,/* MultiValueContainer,*/ ValueContainer
                }}
                // className={customClassName}
                // showExtraButton={showExtraButton && !isDisabled}
                // onClickExtraButton={onClickExtraButton}
            />)
    }

}
CreatableSelectWrapper.propTypes = {
    value: PropTypes.any,
    options: PropTypes.array,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    formatCreateLabel: React.PropTypes.string,
}



// WEBPACK FOOTER //
// ./components/ClaimsWizard/shared/WizardSelects/WizardReactSelect.jsx